import { Button, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import PlayerNotesCrud from "./PlayerNotesCrud"; // Asegúrate de que la ruta sea correcta
import { toast } from "react-toastify";

export default function PlayerNotes(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "100%",
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));

  const classes = useStyles();
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  const [playerNotes, setPlayerNotes] = useState([]);
  const [messagesSelected, setMessagesSelected] = useState([]);
  const [messageEdit, setMessageEdit] = useState();
  const [open, setOpen] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [msgSuccess, setMsgSuccess] = useState(false);

  useEffect(() => {
    let IdPlayer = props.Player.idPlayer;

    const url =
      process.env.REACT_APP_API2_URL +
      "/Player/PlayerMessages_GetList?idPlayer=" +
      IdPlayer;
    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {

      setPlayerNotes(response.data);
    });
  }, [props.Player.IdPlayer, msgSuccess]);

  const handleClickOpen = () => {
    setOpen(true);
    setEditFlag(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
  };

  function PlayerMessagesDelete() {
    let newMessage = [{
      IdPlayer: props.Player.IdPlayer,
      IdUser: userInfo.userId,
      IdPlayerMessage: messageEdit.IdPlayerMessage
    }]
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Player/PlayerMessages_Delete",
      data: newMessage,
    }).then((response) => {
      console.log("response", response);
      toast.success(`Message deleted successfully`);
      // closeModal(); // Cierra el modal después de la inserción exitosa
      GetPlayerMessages();
    });
  }

  function GetPlayerMessages() {
    let IdPlayer = props.Player.idPlayer;

    const url =
      process.env.REACT_APP_API2_URL +
      "/Player/PlayerMessages_GetList?idPlayer=" +
      IdPlayer;
    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      console.log("PROPS====== PlayerNotes THEN", response.data);
      setPlayerNotes(response.data);
    });
  }

  function onRowSelect(row, isSelected, e) {
    const newMessage = {
      IdPlayerMessage: row.idPlayerMessage,
      IdPlayer: props.Player.idPlayer,
      IdUser: userInfo.userId,
    };

    if (isSelected) {
      setMessagesSelected([newMessage]);
      setMessageEdit(row);
      console.log("Está seleccionado====>", [newMessage]);
    }
  }

  const EditMessageClick = () => {
    setEditFlag(true);
    setOpen(true);
  }

  const toggleSuccess = () => {
    setMsgSuccess(!msgSuccess)
  }

  const selectRowProp = {
    mode: "radio",
    clickToSelect: true,
    clickToExpand: true,
    onSelect: onRowSelect,
  };

  const typeFormatter = (cell, row) => {
    return (
      <>
        <div className=''>
          {row.MessageType == 0 ? "Normal" : "Permanent"}
        </div>
      </>
    );
  };

  const expirationDateFormatter = (cell, row) => {
    return (
      <>
        <div className=''>
          {row.UseExpirationDate ? row.ExpirationDate : "None"}
        </div>
      </>
    );
  };

  const displayLeftFormatter = (cell, row) => {
    return (
      <>
        <div className=''>
          {row.UseDisplayCounter ? row.DisplayCounter : "-"}
        </div>
      </>
    );
  };

  const closedOptionFormatter = (cell, row) => {
    return (
      <>
        <div className=''>
          {row.UseCloseOption ? "No" : "-"}
        </div>
      </>
    );
  };

  return (
    <React.Fragment>
      <Table>
        <TableBody>
          <BootstrapTable
            data={playerNotes}
            options={options}
            selectRow={selectRowProp}
          >
            <TableHeaderColumn
              dataField="idPlayerMessage"
              isKey
              hidden
              hiddenOnInsert
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn visible="none" hidden dataField="IdPlayer">
              IdPlayer
            </TableHeaderColumn>

            <TableHeaderColumn dataField="message">Message</TableHeaderColumn>
            <TableHeaderColumn dataField="messageType" dataFormat={typeFormatter}>
              Message Type
            </TableHeaderColumn>
            <TableHeaderColumn dataField="expirationDate" dataFormat={expirationDateFormatter}>
              Expiration Date
            </TableHeaderColumn>
            <TableHeaderColumn dataField="displayCounter" dataFormat={displayLeftFormatter}>
              Displays Left
            </TableHeaderColumn>
            <TableHeaderColumn dataField="closed" dataFormat={closedOptionFormatter}>Closed</TableHeaderColumn>
          </BootstrapTable>
          <br></br>
          <Button
            color="primary"
            variant="contained"
            onClick={handleClickOpen}
            style={{ marginRight: '10px' }} /* Ajusta este valor para el espaciado deseado */
          >
            New
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={EditMessageClick}
            style={{ marginRight: '10px' }} /* Ajusta este valor para el espaciado deseado */
          >
            Edit
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={PlayerMessagesDelete}
          >
            Delete
          </Button>
        </TableBody>
      </Table>
      <br></br>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Player Notes</DialogTitle>
        <DialogContent>
          <PlayerNotesCrud
            handleClose={handleClose}
            edit={editFlag}
            Message={messageEdit}
            userInfo={userInfo}
            idPlayer={props.Player.idPlayer}
            msgSuccess={toggleSuccess}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}